import React, { useState, useEffect } from 'react';
import { Upload, Form, Input } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import notification from '../../../elements/lib/NotificationWrapper';
import { Translation, getI18n } from 'react-i18next';

// upload criteria
const fileTypesImage = {
  'image/png': 'png',
  'image/jpeg': 'jpg',
};

const fileSizeLimit = 1024 * 1024 * 6;

const CoverImageUpload = ({
  form,
  field,
  cover_image,
  cover_image_id,
  getSignedUrl,
  setDeleteImageIds,
  deleteImageIds,
}) => {
  const [uploadedCoverImage, setUploadedCoverImage] = useState(null);

  const propsCoverImage = {
    multiple: false,
    onChange(info) {
      const fileList = info.fileList;
      setUploadedCoverImage(fileList);

      const modulesArr = form.getFieldValue('modules') || [];
      modulesArr[field.name] = {
        ...(modulesArr[field.name] || {}),
        cover_image: fileList,
      };

      form.setFieldsValue({ modules: modulesArr });
      form.validateFields([['modules', field.name, 'cover_image']]);
    },
    beforeUpload(file) {
      const isSupportedFileType = Object.keys(fileTypesImage).includes(
        file.type
      );
      if (!isSupportedFileType) {
        notification.error(
          getI18n().t('learning_admin_form_input_cover_image_file_types')
        );
        setUploadedCoverImage(null);
        return Upload.LIST_IGNORE;
      }
      const isUnderFileSizeLimit = file.size < fileSizeLimit;
      if (!isUnderFileSizeLimit) {
        notification.error(
          getI18n().t('learning_admin_form_input_image_file_size_limit')
        );
        setUploadedCoverImage(null);
        return Upload.LIST_IGNORE;
      }
      return false;
    },
  };

  const handleRemove = () => {
    if (cover_image && cover_image_id) {
      if (deleteImageIds.includes(cover_image_id) === false) {
        setDeleteImageIds([...deleteImageIds, cover_image_id]);
      }
    }

    setUploadedCoverImage(null);
    const modulesArr = form.getFieldValue('modules') || [];
    modulesArr[field.name] = {
      ...(modulesArr[field.name] || {}),
      cover_image: undefined,
      cover_image_id: undefined,
    };
    form.setFieldsValue({ modules: modulesArr });
    form.validateFields([['modules', field.name, 'cover_image']]);
  };

  useEffect(() => {
    if (cover_image && cover_image.id) {
      if (
        cover_image['file_directory'] &&
        cover_image['file_name'] &&
        cover_image['file_extension']
      ) {
        const size = 160;
        const path = `ratio/${size}x${size}/${cover_image['file_directory']}/${cover_image['file_name']}.${cover_image['file_extension']}`;

        getSignedUrl(path, (success, signedUrl) => {
          if (success) {
            const defaultFile = [
              {
                uid: cover_image['id'],
                name: cover_image['file_name'],
                url: signedUrl,
                thumbUrl: signedUrl,
                status: 'done',
              },
            ];
            setUploadedCoverImage(defaultFile);
          }
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cover_image]);

  return (
    <Translation>
      {(t) => (
        <>
          <div className='form-group'>
            <Form.Item
              name={[module.name, 'cover_image_id']}
              style={{ display: 'none' }}
            >
              <Input type='hidden' />
            </Form.Item>
          </div>

          <div className='form-group'>
            <div
              className='ant-col ant-col-24 ant-form-item-label'
              style={{ paddingBottom: 0 }}
            >
              <label className='ant-form-item-required'>
                {t('learning_admin_form_input_cover_image')}
              </label>
            </div>
            <Form.Item
              name={[field.name, 'cover_image']}
              fieldKey={[field.fieldKey, 'cover_image']}
              rules={[
                { required: true, message: 'Missing data for required field.' },
              ]}
            >
              {uploadedCoverImage === null ||
              uploadedCoverImage.length === 0 ? (
                <Upload.Dragger {...propsCoverImage}>
                  <p className='ant-upload-drag-icon'>
                    <InboxOutlined />
                  </p>
                  <p className='ant-upload-text'>
                    {t('learning_admin_form_input_image_drag_and_drop_upload')}
                  </p>
                  <p className='ant-upload-hint'>
                    {t(
                      'learning_admin_form_input_cover_image_drag_and_drop_types'
                    )}
                  </p>
                </Upload.Dragger>
              ) : (
                <Upload
                  className='upload-file'
                  fileList={uploadedCoverImage}
                  listType='picture'
                  multiple={false}
                  onRemove={handleRemove}
                />
              )}
            </Form.Item>
          </div>
        </>
      )}
    </Translation>
  );
};

export default CoverImageUpload;
